import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  ActionIcon,
  Group,
  Paper,
  Skeleton,
  Stack,
  Text,
  Tooltip,
} from "@mantine/core";
import { useClickOutside } from "@mantine/hooks";
import { IconExclamationCircleFilled } from "@tabler/icons-react";

import { StyledOverviewCard } from "../OverviewCard/OverviewCard.styled";


interface EarningsOverviewCardProps {
  icon?: React.ReactNode;
  title?: string;
  amount?: number;
  previousAmount?: number;
  amountPostfix?: string;
  isLoading?: boolean;
  showAlertInfo?: string;
  numOfServices?: number;
}

export const EarningsOverviewCard = ({
  icon,
  title,
  amount,
  amountPostfix,
  isLoading = true,
  showAlertInfo,
  numOfServices = 0,
}: EarningsOverviewCardProps) => {
  const { t, i18n } = useTranslation();
  const [showTooltip, setShowTooltip] = useState(false);
  const ref = useClickOutside(() => setShowTooltip(false));

  return (
    <StyledOverviewCard>
      <Paper withBorder p="md" radius="md">
        <Group justify="space-between" gap={"xs"}>
          <Text fz={15} fw={500}>
            {title}
          </Text>
          {icon}
        </Group>

        {isLoading ? (
          <Skeleton h={28} w={"20%"} mt={25} />
        ) : (
          <Stack gap={"0.5rem"}>
            <Group justify="" gap={"5"} align="end">
              <Text
                mt={25}
                fz={28}
                fw={500}
                lh={1}
                // ff={"var(--font-secondary)"}
              >
                {amount?.toLocaleString(i18n.language)}
                {amountPostfix ? ` ${amountPostfix}` : ""}
              </Text>
              {showAlertInfo && (
                <Tooltip
                  ref={ref}
                  opened={showTooltip}
                  label={showAlertInfo}
                  fw={500}
                  bg={"red.1"}
                  c="red.8"
                  // py={"sm"}
                  multiline
                  ta={"center"}
                  maw={250}
                  withArrow>
                  <ActionIcon
                    variant="subtle"
                    color="red"
                    onClick={() => setShowTooltip(a => !a)}>
                    <IconExclamationCircleFilled
                      size={29}
                      color="var(--mantine-color-red-6)"
                    />
                  </ActionIcon>
                </Tooltip>
              )}
            </Group>
            {numOfServices || numOfServices === 0 ? (
              <Text fz={14} c="dimmed">
                {t("across-services", { count: numOfServices })}
              </Text>
            ) : null}
          </Stack>
        )}
      </Paper>
    </StyledOverviewCard>
  );
};
